import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import { Panel, PanelBody } from "../panel/panel.jsx";

class ModalClasificacion extends Component {
  render() {
    return (
      <Modal
        isOpen={this.props.state.openModalClasificacion}
        tabIndex="-1"
        style={{
          maxWidth: "100%",
          width: "90%",
        }}
      >
        <ModalHeader
          width="100%"
          toggle={(e) => {
            this.props.component.closeClasificacion(e)
          }}
          className="text-center"
        >
          Clasifique este producto
        </ModalHeader>
        <ModalBody>
        <fieldset className="panel">
          <div id="modal_clasificacion">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label style={{ textAlign: "center"}}>
                    Grupo de riesgo: <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="grupo_ingrediente_id"
                    id="grupo_ingrediente_id"
                    onChange={this.props.component.handleChangeClasificacion}
                    value={this.props.state.clasificacion.grupo_ingrediente_id}
                    className="form-control"
                  >
                    <option value="">Seleccione</option>
                    {this.props.state.cat_grupo_ingrediente.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className={this.props.state.tipo_producto_veterinario ? "col-lg-12": "hide"}>
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Clasificación de producto:{" "}
                    <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="clase_producto_id"
                    id="clase_producto_id"
                    onChange={this.props.component.handleChangeClasificacion}
                    value={this.props.state.clasificacion.clase_producto_id}
                    className="form-control"
                  >
                    <option value="">Seleccione</option>
                    {this.props.state.option_clase_producto.map(
                      (option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Categoría de venta: <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="categorizacion_oficial_id"
                    id="categorizacion_oficial_id"
                    onChange={this.props.component.handleChangeClasificacion}
                    value={
                      this.props.state.clasificacion.categorizacion_oficial_id
                    }
                    className="form-control"
                  >
                    <option value="">Seleccione</option>
                    {this.props.state.cat_categorizacion_oficial.map(
                      (option) => (
                        <option key={option.id} value={option.id}>
                          {option.descripcion}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Tomo: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="tomo"
                    id="tomo"
                    maxLength={25}
                    onChange={this.props.component.handleChangeClasificacion}
                    value={this.props.state.clasificacion.tomo}
                    className="form-control"
                    placeholder="Tomo"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Folio: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="folio"
                    id="folio"
                    maxLength={20}
                    onChange={this.props.component.handleChangeClasificacion}
                    value={this.props.state.clasificacion.folio}
                    className="form-control"
                    placeholder="Folio"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Número de registro: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="number"
                    name="no_registro_drycip"
                    id="no_registro_drycip"
                    min={1}
                    onChange={this.props.component.handleChangeClasificacion}
                    value={this.props.state.clasificacion.no_registro_drycip}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Dossier: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    name="dossier"
                    id="dossier"
                    maxLength={20}
                    onChange={this.props.component.handleChangeClasificacion}
                    value={this.props.state.clasificacion.dossier}
                    className="form-control"
                    placeholder="Dossier"
                  />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="form-group">
                  <label className="style='text-align: center;'">
                    Solicitar revisión de asesoría legal:{" "} 
                    <span className="text-danger"> *</span>
                    {" "}
                  </label>
                  <input
                    //className="style='width: 30px; height: 30px;'"
                    type="checkbox"
                    id="asesoria"
                    onChange={this.props.component.handleChangeClasificacion}
                    name="asesoria"
                    value={
                        this.props.state.clasificacion.asesoria || false
                    }
                    checked={this.props.state.clasificacion.asesoria || false}
                />
                </div>
              </div>
            </div>
          </div>
          </fieldset>
        </ModalBody>
        <ModalFooter>
          <div className="container p-0">
            <div className="row">
              <div className="col-lg-12">
                <div className="btn-group pull-right col-md-3">
                  <button
                    className="btn btn-danger"
                    onClick={(e) => {
                      this.props.component.closeClasificacion(e)
                    }}
                  >
                    Regresar
                  </button>

                  <button
                    onClick={(e) => {
                      this.props.component.setClasificacion(e)
                    }}
                    value="5"
                    id="aprobar_form"
                    className="btn btn-success "
                  >
                    Clasificar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default ModalClasificacion;
